import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { getBgSettings, saveBgSettings, BG_IMAGES } from '../utils/backgroundSettings';
import './BackgroundSettingsPanel.css';

const BackgroundSettingsPanel = ({ onClose, onChange }) => {
  const [settings, setSettings] = useState(getBgSettings());

  const update = (next) => {
    console.log('[BackgroundSettingsPanel] settings updated:', next);
    setSettings(next);
    saveBgSettings(next);
    if (onChange) onChange(next);
  };

  const toggleEnabled = (e) => {
    update({ ...settings, enabled: e.target.checked });
  };

  const setMode = (mode) => {
    update({ ...settings, mode });
  };

  const selectImage = (index) => {
    update({ ...settings, mode: 'image', selectedIndex: index });
  };

  useEffect(() => {
    // lock body scroll while panel is open
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = original; };
  }, []);

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="bg-panel" onClick={e => e.stopPropagation()}>
        <div className="bg-panel-header">
          <h2>Virtual Background</h2>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        <label className="bg-toggle">
          <input type="checkbox" checked={settings.enabled} onChange={toggleEnabled} />
          <span>Enable virtual background</span>
        </label>

        {settings.enabled && (
          <>
            <div className="bg-mode-row">
              <button
                className={`bg-mode-btn ${settings.mode === 'blur' ? 'active' : ''}`}
                onClick={() => setMode('blur')}
              >
                Blur
              </button>
              <button
                className={`bg-mode-btn ${settings.mode === 'image' ? 'active' : ''}`}
                onClick={() => setMode('image')}
              >
                Image
              </button>
            </div>

            {settings.mode === 'image' && (
              <div className="bg-grid">
                {BG_IMAGES.map((src, i) => (
                  <button
                    key={src}
                    className={`bg-thumb ${settings.selectedIndex === i ? 'selected' : ''}`}
                    onClick={() => selectImage(i)}
                    style={{ backgroundImage: `url(${src})` }}
                    aria-label={`Background ${i + 1}`}
                  />
                ))}
              </div>
            )}

            <p className="bg-hint">
              You can change this at any time, even during an active call.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default BackgroundSettingsPanel;
